import * as kea from "kea-react";
import * as React from "react";
import { contains, createSelector, union, exclude, isSubset, setEquals } from "keautils";
import { componentToRx } from "app/main/std";

interface PropsG<T, TKey> {
    /**Indices seleccionados */
    value: TKey[];
    onChange?: (x: TKey[]) => void;

    /**Elementos del grid */
    items: T[];
    /**Obtiene la clave de un item */
    getKey: (x: T) => TKey;
    /**Columnas a mostrar en el grid */
    columnas: kea.Grid2Column<T>[];
    cookieKey?: string;
    hideBusqueda?: boolean;
}

const selectedProp = "__selected__";
interface TSelected<T> {
    [selectedProp]: boolean
};

interface Deps<T> {
    onSeleccionar: (x: TSelected<T>, value: boolean) => void;
    onTodos: (value: boolean) => void;
    todos: boolean | null;
}

export class SelectorHeader extends React.PureComponent<{onTodos: (x: boolean) => void, todos:boolean | null}> {
    render() {
        return (
            <th>
                <kea.Checkbox value={this.props.todos} onChange={x => this.props.onTodos(x)}  />
            </th>
        )
    }
}

function columnas<T>(deps: Deps<T>, columnas: kea.Grid2Column<T>[]) {
    const ret: kea.Grid2Column<TSelected<T>>[] = [
        {
            title: "",
            key: "seleccionar",
            cell: x => ({
                data: x[selectedProp],
                view: () => <kea.Checkbox value={x[selectedProp]} onChange={sel => deps.onSeleccionar(x, sel)} />
            }),
            render: () => <SelectorHeader onTodos={deps.onTodos} todos={deps.todos} />
        },
        ... (columnas as any)
    ];
    return ret;
}

const toSelected = <T, TKey>(items: T[], selected: TKey[], getKey: (x: T) => TKey) =>
    items.map<TSelected<T>>(x => ({ ... (x as any), [selectedProp]: contains(selected, getKey(x)) }));

type Props = PropsG<any,any>;

/**Un grid multiselector */
class MultiselectorNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    items = (props: Props) => props.items;
    getKey = (props: Props) => props.getKey;
    columnas = (props: Props) => props.columnas;
    todos = createSelector(this.items, this.value, this.getKey, (items, value, getKey) => setEquals(items.map(getKey), value ) );
    columnasSel = createSelector(this.columnas, this.todos, (cols, todos) => columnas({
        onSeleccionar: this.onSeleccionar,
        onTodos: this.onTodos,
        todos: todos
    }, cols));

    itemsSelected = createSelector(this.items, this.value, this.getKey, toSelected);


    onTodos = (x: boolean) => {
        if(!this.props.onChange)
            return;

        const next = x ? this.items(this.props).map(this.getKey(this.props)) : [];
        this.props.onChange(next);
    }

    onSeleccionar = (item: any, selected: boolean) => {
        if(!this.props.onChange)
            return;

        const old = this.value(this.props);
        const key = this.getKey(this.props)(item);
        const next = selected ? union(old, [key]): exclude(old, [key]);

        this.props.onChange(next);
    };

    render() {
        return (
            <kea.Grid2 
                {... this.props}
                items={this.itemsSelected(this.props)}
                columnas={this.columnasSel(this.props)}
            />
        )
    }
}

export const  Multiselector = componentToRx(MultiselectorNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/multiselector.tsx